import { Grid, IconButton } from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import { useCallback, useState } from "react";
import { isSameDate } from "../../../utils";
import DeleteForever from "@material-ui/icons/DeleteForever";

export type ListDatesPickerProps = {
  value: Date[];
  onChange: (v: Date[]) => void;
};
export default function ListDatesPicker(props: ListDatesPickerProps) {
  const { value, onChange } = props;
  const [d, setD] = useState<Date | null | undefined>(null);

  const onDateChange = useCallback(
    (newDate: Date | undefined | null) => {
      if (newDate && !value.some((v) => isSameDate(newDate, v))) {
        const newValue = [...value, newDate];
        newValue.sort((a, b) => b.getTime() - a.getTime());

        onChange(newValue);
        setD(void 0);
      }
    },
    [onChange, value]
  );

  const triggerRemoveDate = (index) => {
    const valueCopy = [...value];
    valueCopy.splice(index, 1);

    onChange([...valueCopy]);
  };

  return (
    <Grid container style={{ width: "100%" }} spacing={3}>
      <Grid item xs={12}>
        <DatePicker
          value={d}
          onChange={(v) => onDateChange(v)}
          format="dd/MM/yyyy"
          label="Data da aggiungere"
          inputVariant="outlined"
        />
      </Grid>
      {value.map((d, idx) => (
        <Grid item xs={12} md={3} lg={2} xl={1}>
          {d.toLocaleDateString()}
          <IconButton onClick={() => triggerRemoveDate(idx)}>
            <DeleteForever />
          </IconButton>
        </Grid>
      ))}
    </Grid>
  );
}
